<template>
  <div class="cps">
    <div><span>修改密码</span></div>
    <div><el-input v-model="oldpss" type="text" placeholder="输入密码"></el-input></div>
    <div><el-input v-model="newpass1" type="password" placeholder="输入新的密码"></el-input></div>
    <div><el-input v-model="newpass2" type="password" placeholder="重复输入新的密码"></el-input></div>
    <div><el-button class="fullbutton" v-on:click="changpass">修改密码</el-button></div>
    <div style="color: red;">
      <span>密码设置规则:</span>
      <br />
      <span>1 长度为8--16位</span>
      <br />
      <span>2 只能包含大写字母、小写字母和数字</span>
      <br />
      <span>3 必须包含大写字母</span>
      <br />
      <span>4 必须包含小写字母</span>
      <br />
      <span>5 必须包含数字</span>
      <br />
      <span>6 密码与账号不能相同</span>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      oldpss: '',
      newpass1: '',
      newpass2: ''
    };
  },
  methods: {
    checkPass(pass) {
      if (pass.length < 6) {
        return 0;
      }
      var ls = 0;
      if (pass.match(/([a-z])+/)) {
        ls++;
      }
      if (pass.match(/([0-9])+/)) {
        ls++;
      }
      if (pass.match(/([A-Z])+/)) {
        ls++;
      }
      if (pass.match(/[^a-zA-Z0-9]+/)) {
        ls++;
      }
      return ls;
    },
    changpass() {
      if (this.newpass1 != this.newpass2) {
        this.$toast.fail('两次输入的密码不一致！');
      } else if (this.newpass1.length < 6) {
        this.$toast.fail('密码必须超过6位！');
      }else if(this.checkPass(this.newpass1)<3){
        this.$toast.fail('密码复杂度不够！');
      } else {
        let that = this;
        this.$ajax.post('/changpassword', { pwd: this.newpass1,oldpwd:this.oldpss }).then(function(res) {
          if (res.code == 200) {
            that.$toast.success('密码修改成功！');
            that.$router.push('/studentmain');
          }else{
            that.$toast.fail("密码修改失败，请检查原密码和登录状态")
          }
        });
      }
    }
  }
};
</script>

<style>
.cps {
  display: flex;
  flex-direction: column;
}
.cps div {
  margin-top: 20px;
  flex: 1;
}
.fullbutton {
  margin-top: 40px;
  background-color: #ff962a;
  width: 100%;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/changPass.vue